export const validateMaxLength = (input, maxChars = 10) => {
    if (input?.length > maxChars) {
        return `*Please input a value not greater than ${maxChars} digits`;
    }
    return null;
};
export const validateCharacters = (input) => {
    const regex = /^\d+$/;
    if (!regex.test(input)) {
        return '*Valid Characters include 0-9';
    }
    return null;
};

export const validateCharactersWithComma = (input) => {
    const regex = /^(([0-9]+)(,[0-9]{3})*(\.[0-9]+)?)?$/g;
    if (!regex.test(input)) {
        return '*Valid Characters include 0-9 ,';
    }
    return null;
};
export const validateAllowedCharacters = (input) => {
    // Accepts: optional $, digits (with or without commas), optional decimal, optional k/m/b (case-insensitive)
    const regex = /^\$?((\d{1,3}(,\d{3})+)|(\d+))(\.\d*)?([kmbKMB])?$/;
    if (!regex.test(input)) {
        return '*Valid Characters include 0-9 k m b $ ,';
    }
    return null;
};

export const validateDistance = (input) => {
    const regex = /^(^([0-9]+(\.[0-9]+)?)(km|Km|kM|KM)?)?$/g;
    if (!regex.test(input)) {
        return '*Valid Characters include 0-9 . km';
    }
    return null;
};

export const validateStreetFrontage = (input) => {
    const regex = /^(^([0-9]+(\.[0-9]+)?)(m|M)?)?$/g;
    if (!regex.test(input)) {
        return '*Valid Characters include 0-9 . m';
    }
    return null;
};

export const validateFloorArea = (input) => {
    const regex = /^(([0-9]+)(,[0-9]{3})*(m2|M2|m\u00B2|M\u00B2)?)?$/g;
    if (!regex.test(input)) {
        return '*Valid Characters include 0-9 m2 ,';
    }
    return null;
};

export const validateMinMax = (key, value, otherValue) => {
    const isValueGreaterThanOtherValue = (val, otherVal) => {
        try {
            if (val === undefined || otherVal === undefined) {
                return true;
            }
            if (val === '' || otherVal === '') {
                return false;
            }
            return Number(val) > Number(otherVal);
        } catch (e) {
            return false;
        }
    };

    // Check comparison error first when one value is undefined
    if (key === 'max') {
        if (isValueGreaterThanOtherValue(otherValue, value)) {
            return '*Please input a max value greater than min value.';
        }
    } else {
        if (isValueGreaterThanOtherValue(value, otherValue)) {
            return '*Please input a max value greater than min value.';
        }
    }
};

export const validateDecimalPlaces = (input, maxDecimals = 2) => {
    const match = input.toString().match(/\.(\d+)/);
    if (match && match[1].length > maxDecimals) {
        return `*Max ${maxDecimals} decimal places`;
    }
    return null;
};

export const validatePrice = (input) => {
    return (
        validateAllowedCharacters(input) ||
        validateMaxLength(input) ||
        validateDecimalPlaces(input)
    );
};